// ABOUTME: Utility functions for authentication and redirect handling
// ABOUTME: Provides secure URL validation for post-login redirects

import { getCurrentAccessToken } from '../services/api';

/**
 * Validates if a redirect URL is safe for internal navigation
 * @param url - The URL to validate
 * @returns true if the URL is safe to redirect to
 */
export const isValidRedirectUrl = (url: string | null): boolean => {
  if (!url) return false;
  
  // Must start with / and not be a protocol or double slash
  return url.startsWith('/') && 
         !url.startsWith('//') && 
         !url.includes(':') &&
         !url.includes('..');
};

/**
 * Gets a safe redirect URL from the current location
 * @returns A validated redirect URL or '/' as default
 */
export const getSafeRedirectUrl = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const redirect = urlParams.get('redirect');
  
  // Validate the redirect parameter
  if (!isValidRedirectUrl(redirect)) {
    return '/';
  }
  
  // Don't redirect to auth pages
  const authPages = ['/setup', '/reset-password', '/forgot-password', '/login', '/register'];
  if (authPages.some(page => redirect!.startsWith(page))) {
    return '/';
  }
  
  return redirect!;
};

/**
 * Checks if the current path is an auth-related page
 * @param path - The path to check
 * @returns true if the path is auth-related
 */
export const isAuthPage = (path: string): boolean => {
  const authPages = ['/setup', '/reset-password', '/forgot-password', '/login', '/register'];
  return authPages.some(page => path.startsWith(page));
};

/**
 * Checks if user is currently authenticated
 * @returns true if user has a valid auth token
 */
export const isUserAuthenticated = (): boolean => {
  const token = getCurrentAccessToken();
  return !!token;
};